import React from 'react';
import {
    Divider,
    useAppDisplayModeContext,
    useStyles,
    useTheme,
} from '@archipro-design/aria';
import * as S from './StockAndShipping.style';
import { useVariantStock } from '../../hook/use-variant-stock';
import ClickAndCollect from './ClickAndCollect';
import { useTracker } from '@archipro-website/tracker';
import { useVariantSelectionState } from '../../context/VariantSelectionContext';
import TradeOnlyTag from './TradeOnlyTag';
import Delivery from '@modules/product/component/variant-purchase/Delivery';
import { Loader } from '@archipro-design/aria';
import ShippingPopup from '@modules/ecommerce/component/shipping-popup/ShippingPopup';
import { useVariantShippingMethods } from '@modules/ecommerce/context/VariantShippingMethodsContext';
import { useVariantShipping } from '~/modules/product/hook/use-variant-shipping';

const StockAndShipping = () => {
    const { hasClickAndCollect, hasShippingType } = useVariantShipping();
    const { stockDescription, hasLeadTime, canAddToCart, showAsInStock } =
        useVariantStock({ hasClickAndCollect, hasShippingType });
    const { isLoading } = useVariantShippingMethods();
    const { selectedVariant } = useVariantSelectionState();
    const [modalOpen, setModalOpen] = React.useState(false);
    const { mobile } = useAppDisplayModeContext();
    const theme = useTheme();
    const tracker = useTracker();

    const showTradeOnly =
        !canAddToCart &&
        selectedVariant?.TradeOnlyEnabled &&
        selectedVariant?.TradePrice;

    const { css } = useStyles({
        showTradeOnly: Boolean(showTradeOnly),
    });

    return (
        <div className={css(S.StockAndShipping)}>
            {isLoading && <Loader />}
            {!isLoading && (
                <>
                    <div className={css(S.Stock)}>{stockDescription}</div>
                    {showAsInStock && (
                        <>
                            {showTradeOnly && (
                                <div className={css(S.TradeOnlyContainer)}>
                                    <TradeOnlyTag />
                                </div>
                            )}
                            <Delivery
                                isSample={false}
                                onRegionClick={() => {
                                    tracker.log('ShippingLocationModalOpen', {
                                        url: new URL(window.location.href),
                                        targetTracker: 'archiproTracker',
                                    });
                                    canAddToCart && setModalOpen(true);
                                }}
                                hasLeadTime={hasLeadTime}
                            />
                            <ClickAndCollect
                                isSample={false}
                                onLocationClick={() =>
                                    canAddToCart && setModalOpen(true)
                                }
                                hasLeadTime={hasLeadTime}
                            />
                        </>
                    )}
                </>
            )}
            <ShippingPopup
                open={modalOpen}
                closeOnOutsideClick
                onCancel={() => setModalOpen(false)}
                onConfirm={() => setModalOpen(false)}
                isSample={false}
            />
            {mobile && (
                <Divider
                    className={css(S.Divider)}
                    size={1}
                    variables={{
                        dividerPrimaryColor:
                            theme.siteVariables.colors.grey[125],
                    }}
                />
            )}
        </div>
    );
};

export default StockAndShipping;
